import { render, staticRenderFns } from "./HealthCheckList.vue?vue&type=template&id=67e0020f&scoped=true&"
import script from "./HealthCheckList.vue?vue&type=script&lang=js&"
export * from "./HealthCheckList.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheckList.vue?vue&type=style&index=0&id=67e0020f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0020f",
  null
  
)

export default component.exports